import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { isShowLanguageSwitcher } from 'constants/i18next/i18next.consts';
import { useAppDispatch } from 'store/store';
import { selectWebimShouldUpdate } from 'store/webim-reducer/webim.selectors';

import { LanguageSwitcher } from 'components/logic/InnerLayout/components/ui/LanguageSwitcher';
import { RequiredText } from 'components/ui/RequiredText';
import { WebimLink } from 'components/ui/Webim';
import { getQueryParams } from 'utils/common/getQueryParams';
import { IS_TRIAL_USER, TRIAL_LINK_FROM } from 'utils/constants/trial-localstorage';
import { TRIAL_LINK, TRIAL_LINK_PAGE } from 'utils/constants/trial-query-params';
import { gtmViewRegistrationPageTrialMiner } from 'utils/gtmSender/gtmSender';
import { AppRoute } from 'utils/route/app-route';

import { OuterHeader } from './components/ui/OuterHeader';

import * as S from './OuterLayout.styled';

export const OuterLayout: React.FC = () => {
  const dispatch = useAppDispatch();
  const { shouldUpdateState } = useSelector(selectWebimShouldUpdate);

  useEffect(() => {
    if (!shouldUpdateState) return;
    window.location.reload();
  }, [shouldUpdateState, dispatch]);

  const isTrialUser = getQueryParams(TRIAL_LINK, (param) => {
    return Boolean(param);
  });
  const trialLinkPage = getQueryParams(TRIAL_LINK_PAGE);

  useEffect(() => {
    isTrialUser && trialLinkPage && gtmViewRegistrationPageTrialMiner(trialLinkPage);
  }, [isTrialUser, trialLinkPage]);

  if (isTrialUser) {
    localStorage.setItem(IS_TRIAL_USER, isTrialUser);
    trialLinkPage && localStorage.setItem(TRIAL_LINK_FROM, trialLinkPage);

    return <Navigate to={AppRoute.Registration()} replace />;
  }

  return (
    <>
      {!shouldUpdateState && (
        <S.Wrapper>
          <S.HeaderWrapper>
            <OuterHeader />
            {isShowLanguageSwitcher && (
              <S.LngSwitcherMobile>
                <LanguageSwitcher />
              </S.LngSwitcherMobile>
            )}
          </S.HeaderWrapper>
          <S.ContentWrapper>
            <S.WebimWrapper>
              <Outlet />
              <WebimLink />
            </S.WebimWrapper>
            <RequiredText />
          </S.ContentWrapper>
        </S.Wrapper>
      )}
    </>
  );
};
